import React, { useEffect } from "react";
import lottie from "lottie-web";

const Body = ( props ) => {

  useEffect( () => {
    const animation = lottie.loadAnimation( {
      container : document.querySelector( '#ai_lc_05_01' ),
      path : `${ process.env.PUBLIC_URL }/static/json/ai_lc_05_01.json`,
      renderer : 'svg',
      loop : true,
      autoplay : true
    } );
    animation.setSpeed( 0.65 );
    return () => {
      animation.destroy();
    };
  }, [] );

  return (
    <div className="container">
      <div className="bg-lc-intro"><span /></div>
      <div className="inner">
        <div className="centermiddleBox">
          <div className="centermiddleBox-item">
            <h2 className="lc-intro-tit">{ props.data.stgNm || '' }</h2>
            <div className="lc-intro-info">
              <div className="lc-intro-info_box">
                <p className="tit">문제수</p>
                <p className="txt">{ `${ props.data.qstispList?.length || 0 } 문제` }</p>
              </div>
            </div>
            <div className="lc-intro-info_ani">
              <div className="anim-wrap" id="ai_lc_05_01" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

Body.defaultProps = {
  data : {}
};

export default Body;
